<div style="bottom: 8000px; position: fixed; font-family: 'Poppins' !important">
  <div
    *ngIf="exportingPdf"
    id="pdfExportExperiences"
    class="contentFirstWrapper"
  >
    <div class="contentDivWrapper">
      <div class="contentDivTitleRes">
        <div
          class="summaryExperienceTitle"
          style="
            display: flex;
            column-gap: 1.5rem;
            padding: 0 0 0.5cm 0;
            flex-wrap: wrap;
          "
        >
          <div>
            {{ "Summary of reservations" | translate }}
          </div>
          <div>
            {{ getStartAndEndDate() }}
          </div>
          <div>
            {{ getStartAndEndTime() }}
          </div>
          <div>
            {{ company.name }}
          </div>
        </div>
        <div class="new-logo">
          <img
            alt=""
            src="assets/images/logo-blue-horizontal.svg"
            style="
              width: 150px;
              position: relative;
              display: block;
              float: left;
              margin: 5px;
            "
          />
        </div>
      </div>

      <div
        *ngFor="let sect of this.dataPdf!.results; let j = index"
        class="reservation-print-slot"
      >
        <table class="reservation-print-table">
          <colgroup>
            <col class="col-client" />
            <col
              *ngFor="let l1 of getLabels(sect).slice(0, 3)"
              class="col-label"
            />
            <col *ngIf="getLabels(sect).length > 3" class="col-label" />
            <col
              *ngFor="let l1 of getExtras(sect).slice(0, 3)"
              class="col-label"
            />
            <col *ngIf="getExtras(sect).length > 3" class="col-label" />
            <col class="col-total" />
            <col class="col-due" />
            <col class="col-room" />
            <col class="col-staff" />
            <col class="col-notes" />
          </colgroup>
          <thead>
            <tr class="print-unbreak reservation-print-slot-title">
              <th [attr.colspan]="getPrintColumnCount(sect)">
                <div class="newSummaryExperienceNameLine">
                  <div class="summary-fixed-details">
                    <div
                      class="newSingleReservationHeaderElement"
                      style="width: 5cm"
                    >
                      {{ sect.summary.experienceName }}
                    </div>
                    <div class="newSingleReservationHeaderElement">
                      {{ sect.summary.date | date : "dd/MM/yy" }}
                    </div>
                    <div class="newSingleReservationHeaderElement">
                      {{ formatTime(sect.summary.time) }}
                    </div>
                    <div class="newSingleReservationHeaderElement">
                      {{ "lang_" + sect.summary.language | translate }}
                    </div>
                    <div class="newSingleReservationHeaderElement">
                      {{ "Reservations" | translate }}:
                      {{ sect.summary.totalParticipants }}
                    </div>
                  </div>
                  <div class="summary-labels-and-extras">
                    <div
                      *ngFor="
                        let l1 of labelsAndExtrasJoinSummaryToObjArr(sect)
                      "
                    >
                      <div class="newSingleReservationHeaderElement">
                        {{ l1.labelName }}: {{ l1.labelValue }}
                      </div>
                    </div>
                  </div>
                </div>
              </th>
            </tr>
            <tr class="print-unbreak">
              <th class="reservation-print-th reservation-print-th-client">
                {{ "Client" | translate }}
              </th>
              <th
                class="reservation-print-th"
                *ngFor="let l1 of getLabels(sect).slice(0, 3)"
              >
                {{ l1.labelName }}
              </th>
              <th
                class="reservation-print-th"
                *ngIf="getLabels(sect).length > 3"
              >
                {{ "Other Labels" | translate }}
              </th>
              <th
                class="reservation-print-th"
                *ngFor="let l1 of getExtras(sect).slice(0, 3)"
              >
                {{ l1.labelName }}
              </th>
              <th
                class="reservation-print-th"
                *ngIf="getExtras(sect).length > 3"
              >
                {{ "Other Extras" | translate }}
              </th>
              <th class="reservation-print-th reservation-print-th-amount col-total">
                {{ "Total" | translate }}
              </th>
              <th class="reservation-print-th reservation-print-th-amount col-due">
                {{ "Da pagare" | translate }}
              </th>
              <th class="reservation-print-th col-room">
                {{ "Sala" | translate }}
              </th>
              <th class="reservation-print-th col-staff">
                {{ "Addetto" | translate }}
              </th>
              <th class="reservation-print-th col-notes">
                {{ "Note" | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="print-unbreak"
              *ngFor="let r of sect.reservations; let i = index"
            >
              <td class="reservation-print-td reservation-print-td-client">
                <div
                  class="truncate-text"
                  *ngIf="!r.otherData.isTourOperator"
                >
                  {{ r.masterContactName }}
                </div>
                <div
                  class="truncate-text"
                  *ngIf="r.otherData.isTourOperator"
                >
                  {{ r.reservationContacts[0].first_name }}
                </div>
                <div class="reservation-print-client-meta">
                  <div *ngIf="r.reservationContacts[0].phone_number">
                    {{ r.reservationContacts[0].phone_number.slice(0, 14) }}
                  </div>
                  <div>
                    {{ r.reservationContacts[0].country_iso }}
                  </div>
                </div>
              </td>
              <td
                class="reservation-print-td"
                *ngFor="let l1 of getLabels(sect).slice(0, 3)"
              >
                {{ getLabelOrZero(r, l1.labelName) }}
              </td>
              <td
                class="reservation-print-td"
                *ngIf="getLabels(sect).length > 3"
              >
                {{ getOtherLabelsValue(r, sect) }}
              </td>
              <td
                class="reservation-print-td"
                *ngFor="let l1 of getExtras(sect).slice(0, 3)"
              >
                {{ getExtraOrZero(r, l1.labelName) }}
              </td>
              <td
                class="reservation-print-td"
                *ngIf="getExtras(sect).length > 3"
              >
                {{ getOtherExtrasValue(r, sect) }}
              </td>
              <td class="reservation-print-td reservation-print-td-amount">
                {{ r.netTotalCents / 100 }} €
              </td>
              <td class="reservation-print-td reservation-print-td-amount">
                <ng-container *ngIf="r.dueTotalCents > 0; else daRimborsare">
                  <div style="color: red; text-align: center">
                    {{ r.dueTotalCents / 100 }} €
                  </div>
                </ng-container>
                <ng-template #daRimborsare>
                  <ng-container *ngIf="r.dueTotalCents < 0; else aPosto">
                    <div style="color: green; text-align: center">
                      {{ (r.dueTotalCents / 100) * -1 }} €
                      <p style="font-size: 0.4rem; margin: 0 !important">
                        (Da rimborsare)
                      </p>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #aPosto>
                  <div>0 €</div>
                </ng-template>
              </td>
              <td class="reservation-print-td">
                {{ roomName(r.roomId) }}
              </td>
              <td class="reservation-print-td">
                {{ employeeName(r.employeeId) }}
              </td>
              <td class="reservation-print-td reservation-print-td-notes">
                {{ r.notes }}
                <div *ngIf="r.message">
                  -
                  {{
                    r.message.length > 100
                      ? r.message.slice(0, 70) + "..."
                      : r.message
                  }}
                  -
                </div>
                <div
                  *ngIf="
                    r.otherData &&
                    r.otherData.invoiceData &&
                    r.otherData.invoiceData !== '{}'
                  "
                  style="font-style: italic"
                >
                  {{ "Invoice requested" | translate }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
